import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, styled } from '../../netline-ui';

import EmptyErrorIcon from './EmptyErrorIcon';
import styles, { offlineInfoClasses } from './OfflineInfo.styles';

const OfflineInfoRoot = styled('div', { name: offlineInfoClasses.$name })(styles);

const OfflineInfo = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <OfflineInfoRoot className={offlineInfoClasses.root} data-testid="OfflineInfo-root">
      <EmptyErrorIcon />
      <div className={offlineInfoClasses.errorHeader} data-testid="OfflineInfo-header">
        {t('offline_info.header')}
      </div>
      <div className={offlineInfoClasses.errorInfo} data-testid="OfflineInfo-content">
        {t('offline_info.info')}
      </div>
      <Button primary size="large" className={offlineInfoClasses.backBtn} onClick={handleBack}>
        {t('offline_info.back')}
      </Button>
    </OfflineInfoRoot>
  );
};

export default OfflineInfo;
